import { createSlice } from "@reduxjs/toolkit";

export const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState: {
        _switch: true
    },
    reducers: {
        switchSidebar: (state) => {
            state._switch = !state._switch;
        }
    }
})
  
export const { switchSidebar } = sidebarSlice.actions;
export default sidebarSlice.reducer;